<template>
  <div id="app" v-if="isQB">
    <status-bar v-if="isPlaceHolder" :place-holder="isPlaceHolder"></status-bar>
    <!--    <status-bar v-if="statusBarHeight&&isPlaceHolder" :place-holder="isPlaceHolder"></status-bar>-->
    <!--    <status-bar v-if="statusBarHeight" :place-holder="false"></status-bar>-->
    <router-view/>


  </div>
</template>

<script>
import StatusBar from "@/components/statusBar.vue";
import {mapGetters} from "vuex";
import {Web3} from "web3";
import {getContractInstanceETH, getContractInstanceUSDT, getWeb3Example} from './utils/web3Contract'
import {getCommission} from "@/api/ctc";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {editUserInfo, getDictDetail} from "@/api";
import {MessageBox} from "element-ui";

export default {
  components: {StatusBar},
  data() {
    return {
      a: null,
      web3Vue: null,
      isQB: true,
      isPlaceHolder: false,
    }
  },

  computed: {
    ...mapGetters(['statusBarHeight', 'token'])
  },
  watch: {
    $route: {
      handler: function (n) {
        // console.log('监听路由', n)
        let routeArr = ['shell']
        if (routeArr.includes(n.name)) {
          this.isPlaceHolder = true
        } else {
          this.isPlaceHolder = false
        }
      }
    }
  }


  ,
  async mounted() {

    // if (!window.ethereum) {
    //   this.isQB = false
    // }


    this.web3Vue = await getWeb3Example();
    // const adminList = ['0x44360800Ca20EC6371344A9994526585079523e8']
    this.$store.dispatch('login').then(res => {

      this.$message({
        type: 'success',
        customClass: 'customClass',
        message: '登录成功'
      })


    }).catch(err => {
      this.$message({
        type: 'error',
        customClass: 'customClass',
        message: err
      })
    })
    // await this.$store.dispatch('getAdminKey')
    await this.$store.dispatch('marketAveragePrice')
  },
  methods: {
    toJSON() {
      return this
    },

  }
}
</script>


<style lang="scss">


.boxTontent {
  position: fixed;
  top: 50px;
  left: 50px;
}

* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
  //min-height: 100vh;
}


nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.el-message-box {
  width: auto;
}
</style>
